import { apiClient } from './index.js';
import { sanitizePostData } from '@/utils/index.js';

async function getNotifications() {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/UserNotification/GetNotifications',
  });
  return data;
}

async function hideNotification({ userNotificationId }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/UserNotification/HideNotification',
    data: sanitizePostData({ userNotificationId }),
  });
  return data;
}

async function markNotificationsAsViewed({ userNotificationIds }) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/UserNotification/MarkNotificationsAsViewed',
    data: sanitizePostData({ userNotificationIds }),
  });
  return data;
}

async function getUnreadNotificationCount() {
  const { data } = await apiClient({
    method: 'get',
    url: '/api/UserNotification/GetNotificationCount',
  });
  return data;
}

export {
  getNotifications,
  hideNotification,
  markNotificationsAsViewed,
  getUnreadNotificationCount,
};
